module.exports = __webpack_public_path__ + "img/1.fdc6b420.jpg";